export const getTypeSelectList = (types) => {
  if (Array.isArray(types) && types.length) {
    return types.map(item => ({ value: item.id, label: item.name }));
  }
  return [];
};

export const getSelectedTypeOption = ({ id, name }) => ({
  value: id || '',
  label: name || ''
});

export const localiseType = (arr, i18n) => {
  const types = {
    1: i18n.t`Pre-test`,
    2: i18n.t`Post-test`,
    3: i18n.t`Snapshot check`,
    4: i18n.t`Custom test`
  };

  return arr.map(({ id }) => ({ id, name: types[id] }));
};
